import {Component} from '@angular/core';
import Logger from "./shared/logger";
import {environment} from "../environments/environment";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  constructor() {
    Logger.info(`Vuframe® SharePage v${environment.version}`)
  }


}
